import React, { useEffect, useState } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import './SessionTokenBasedLocation.css'
import { useLoaderData } from "react-router-dom";

const LocationSearchInput = ({ value, placeholder,size,autoSuggestCssClassName,page,setValue,locationObj }) => {
  const [placePredictions, setPlacePredictions] = useState([]);
  const [sessionToken, setSessionToken] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const loaderDetails = useLoaderData();
  const fetchPlacePredictions = async (text, triggerKey) => {
    try {
      const { AutocompleteSessionToken, AutocompleteSuggestion } =
        await window.google.maps.importLibrary("places");

      if (!sessionToken) {
        setSessionToken(new AutocompleteSessionToken());
      }

      const request = {
        input: text,
        sessionToken: sessionToken,
        region: "US",
        includedRegionCodes: loaderDetails?.companyLocations?.length > 0 ? loaderDetails?.companyLocations : ["US"]
      };

      const { suggestions } =
        await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
      // let item = {placePrediction : {text: "Remote"}}
      // setPlacePredictions([item,...suggestions]);
      setPlacePredictions([...suggestions]);
      setShowSuggestions(true);
      if(text === "Remote" && triggerKey === "Enter"){
        locationObj.current.city = "";
        locationObj.current.state = "";
        locationObj.current.country = "";
        locationObj.current.zipcode = "";
        locationObj.current.pin = {}
        locationObj.current.text = text;
        setPlacePredictions([]);
        setShowSuggestions(false);
        setSessionToken(null)
        setActiveIndex(-1)
      }else if (suggestions?.length > 0 && triggerKey === "Enter") {
        const place = suggestions[0].placePrediction.toPlace();
        await place.fetchFields({
          fields: [
            "displayName",
            "formattedAddress",
            "addressComponents",
            "location",
          ],
        });

        const getComponent = (types) =>
          place.addressComponents?.find((c) =>
            types.some((t) => c.types.includes(t))
          )?.longText || "";

          const city = getComponent(["locality", "postal_town"]);
          const state = getComponent(["administrative_area_level_1"]);
          const country = getComponent(["country"]);
          const pincode = getComponent(["postal_code"]);
          const lat = place?.location?.lat() || 0;
          const lng = place?.location?.lng() || 0;
          const fullAddress = place?.formattedAddress || "";
          locationObj.current.city = city;
          locationObj.current.state = state;
          locationObj.current.country = country;
          locationObj.current.zipcode = pincode;
          if(city && city !== ""){
            locationObj.current.pin.lat = lat
            locationObj.current.pin.lon = lng
          }else{
            locationObj.current.pin = {}
          }
          locationObj.current.text = fullAddress;
        setPlacePredictions([]);
        setShowSuggestions(false);
        setSessionToken(null)
        setActiveIndex(-1)
      }
    } catch (error) {
      console.error("Error fetching place predictions:", error);
    }
  };

  const handleKeyDown = async (e) => {
      
    if(e?.key==='Enter' && activeIndex === -1){
      setShowSuggestions(false);
    }
    if(e?.key==='Enter' && page=='Search' && activeIndex === -1){
      setShowSuggestions(false);
      setValue('')
    }
    if (e.key === "Enter" && value.trim() && activeIndex !== -1) {
      e.preventDefault();
      const selectedText =
        placePredictions[activeIndex]?.placePrediction?.text?.toString();
      setValue(selectedText);
      fetchPlacePredictions(selectedText, "Enter");
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < placePredictions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : placePredictions.length - 1
      );
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setValue(value);
    if (value !== "") {
      fetchPlacePredictions(value);
    }else{
        setPlacePredictions([]);
        setShowSuggestions(false)
    }
  };

  const handlePredictionClick = (item, index) => {
    const selectedText =
      placePredictions[index]?.placePrediction?.text?.toString();
    setValue(selectedText);
    fetchPlacePredictions(selectedText, "Enter");
  };

  return (
    <div className="position-relative">
      <Form.Control
        type="text"
        placeholder={placeholder || "Enter your location"}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 300)}
       className={`custom-placeholder no-border`}   
       size={size || 'md'}
      />
      {showSuggestions && placePredictions?.length > 0 && (
        <Card.Body
          // className="position-absolute p-0 m-0 z-3 bg-white shadow mt-1"
          className={`position-absolute p-0 m-0 z-3 bg-white shadow mt-1 cardBodyLocationCss ${autoSuggestCssClassName ? autoSuggestCssClassName :"custom-suggestion-box"}`}
        >
          {placePredictions.map((item, index) => (
            <div
              className={`row border p-0 m-0 pb-2 pt-2 w-100 ${
                activeIndex === index ? "bg-light" : ""
              }`}
              role="button"
              key={item.placePrediction.text.toString()}
              onClick={() => handlePredictionClick(item, index)}
            >
              <div className="col-12">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-primary me-1"
                />
                <span>{item.placePrediction.text.toString()}</span>
              </div>
            </div>
          ))}
        </Card.Body>
      )}
    </div>
  );
};

LocationSearchInput.propTypes = {
  locationObj: PropTypes.any,
  value:PropTypes.any,
  setValue:PropTypes.any,
  size:PropTypes.any,
  autoSuggestCssClassName:PropTypes.any,
  page:PropTypes.any,
  placeholder: PropTypes.any
};

export default LocationSearchInput;